import React from 'react';
import { Switch, useLocation } from 'react-router';
import { SignInPage } from './SignInPage';
import { XrystalSignInPage } from './XrystalSignInPage';
import { ForgotPasswordPage } from './ForgotPasswordPage';
import { CourseRegistrationPage } from './CourseRegistrationPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import { NativeAppLauncherPage } from './NativeAppLauncherPage';
import { ConfirmEmailPage } from './ConfirmEmailPage';
import { UnauthenticatedLayoutRoute } from './UnauthenticatedLayoutRoute';
import { XrystalUnauthenticatedLayoutRoute } from './XrystalUnauthenticatedLayoutRoute';
import { PartnerRegistrationPage } from './PartnerRegistrationPage';

export const nativeAppLauncherPath = '/signin/native-app-launcher';

export const UnauthenticatedPageContainer = React.memo(() => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const brand = searchParams.get('brand');
  const isXrystal = brand === 'xrystal';

  // Choose the appropriate layout route based on brand
  const LayoutRoute = isXrystal ? XrystalUnauthenticatedLayoutRoute : UnauthenticatedLayoutRoute;
  const SignInComponent = isXrystal ? XrystalSignInPage : SignInPage;

  return (
    <>
      <Switch>
        <LayoutRoute exact path="/signin" component={SignInComponent} showSignIn={false} />
        <LayoutRoute exact path={nativeAppLauncherPath} component={NativeAppLauncherPage} />
        <LayoutRoute exact path="/signin/reset-password" component={ResetPasswordPage} />
        <LayoutRoute exact path="/signin/confirm-email" component={ConfirmEmailPage} />
        <LayoutRoute exact path="/signin/forgot-password" component={ForgotPasswordPage} />

        <LayoutRoute exact path="/join/:partnerSlug/:courseSlug" component={CourseRegistrationPage} />
        <LayoutRoute exact path="/join/courses" component={CourseRegistrationPage} />
        <LayoutRoute exact path="/join/partners" component={PartnerRegistrationPage} />
      </Switch>
    </>
  );
});
